import { render, staticRenderFns } from "./OrgaInfoBanner.vue?vue&type=template&id=5a53b991&"
import script from "./OrgaInfoBanner.vue?vue&type=script&lang=ts&"
export * from "./OrgaInfoBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports